<template>
  <div class="search-wrapper">
    <input type="text" v-model="searchText" placeholder="请输入搜索内容">
    <div class="icon" @touchend="toPage()"></div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      searchText: "",
      urlS:''
    };
  },
  computed: {
    ...mapGetters(["searchVuex"])
  },
  mounted() {
    console.log(this.$route.query.nowUrl)
this.urlS = this.$route.query.nowUrl
  },
  methods: {
    ...mapActions(["setSearch"]),
    toSearch() {
    },
    searchCommon() {
      this.searchText = "";
      this.setSearch("");
    },
    toPage() {
      this.setSearch(this.searchText);
      this.$router.push(this.urlS);
    }
  },

};
</script>

<style lang="less" scoped>
@import "./../../common/minix.less";
.search-wrapper {
  width: 100%;
  height: 100 / @rem;
  background: #dbe0ea;
  padding: 10 / @rem 30 / @rem;
  box-sizing: border-box;
  position: relative;
  input {
    width: 100%;
    height: 80 / @rem;
    display: block;
    padding-left: 20 / @rem;
    box-sizing: border-box;
    font-size: 30 / @rem;
    padding-right: 80 / @rem;
    color: #666;
    outline: none;
    border: none;
    background: #eef1f4;
    border-radius: 10 / @rem;
  }
  .icon {
    position: absolute;
    top: 0;
    right: 30 / @rem;
    width: 100 / @rem;
    height: 100 / @rem;
    background: url(/static/img/search.png) no-repeat center center;
    background-size: 34 / @rem 33 / @rem;
  }
}
input:-ms-input-placeholder {
  color: #bbc4d7;
}
</style>



// WEBPACK FOOTER //
// src/components/Search/index.vue